import { render, staticRenderFns } from "./VenueDetailsPage.vue?vue&type=template&id=6ce1afd6&scoped=true"
import script from "./VenueDetailsPage.vue?vue&type=script&lang=js"
export * from "./VenueDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce1afd6",
  null
  
)

export default component.exports